import {
	Component,
	ojs,
	app,
	v,
	state,
} from "modular-openscriptjs";
import {
	either,
	formatThousand,
	pageInfo,
	inform,
} from "../../../helpers";
import { PAGES, gc, uc, dc, STRINGS, api } from "../../../declarations";
import Cropper from "cropperjs";
import { dom, tool } from "../../../fotastart";
import EditProductImageForm from "../../Forms/EditProductImageForm";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

ojs(EditProductImageForm);

export default class Profile extends Component {
	cropper = { obj: null };

	constructor() { 
		super();
	}

	render(userState, ...args) {
		let user = userState?.value;

		if (!user?.id) {
			return h.Loader("dots");
		}

		pageInfo(PAGES.PROFILE);

		return h.div(
			{
				class: "min-vh-100 py-4 pb-5 mb-5 mx-auto w-100 w-md-75 py-md-5",
				style: "max-width: 600px;",
			},
			// Main Container
			h.div(
				{ class: "container px-3" },
				
				// Header
				h.div(
					{ class: "mb-4 d-flex align-items-center justify-content-between" },
					h.div(
						{ class: "d-flex align-items-center gap-3" },
						h.button(
							{
								class: "btn btn-white border shadow-sm circle p-2",
								onclick: "history.back()",
							},
							h.i({ class: "bi bi-arrow-left fs-5 text-secondary" })
						),
						h.h2({ class: "fw-bold mb-0 h4" }, "My Profile")
					)
				),

				// Profile card (Aesthetic details)
				h.div(
					{ class: "card border-0 shadow-sm rounded-4 overflow-hidden mb-4 bg-white" },
					h.div(
						{ 
							class: "p-4 text-center border-bottom position-relative",
							style: "background: linear-gradient(135deg, rgba(151, 62, 135, 0.05), rgba(13, 110, 253, 0.05));"
						},
						// Profile picture/avatar area
						h.div(
							{ class: "position-relative d-inline-block mx-auto mb-3" },
							h.img({
								class: "rounded-circle border border-4 border-white shadow-sm",
								style: "width: 110px; height: 110px; object-fit: cover; cursor: pointer;",
								src: either(user?.profile_photo_path, user?.profile_photo_path, "/assets/images/user-avatar.png"),
								onclick: this.method("changeAvatar"),
							}),
							h.button(
								{
									class: "btn btn-primary btn-sm circle position-absolute border border-2 border-white shadow-sm",
									style: "bottom: 0; right: 0; width: 32px; height: 32px; p-0; display: flex; align-items: center; justify-content: center;",
									onclick: this.method("changeAvatar"),
									title: "Change Profile Picture"
								},
								h.i({ class: "bi bi-camera-fill text-white fs-6" })
							)
						),
						// Name and @username
						h.h4({ class: "fw-bold mb-1 text-dark" }, user?.display_name),
						h.span({ class: "text-muted small fw-semibold" }, `@${user?.username}`)
					),
					
					// Profile Details Body
					h.div(
						{ class: "card-body p-4" },
						h.div(
							{ class: "d-grid gap-3" },
							
							// Email
							h.div(
								{ class: "d-flex align-items-center gap-3 p-2 rounded-3 hover-bg-light transition-all" },
								h.div(
									{ class: "bg-primary-subtle text-primary rounded-3 p-2.5 d-flex align-items-center justify-content-center", style: "width: 40px; height: 40px;" },
									h.i({ class: "bi bi-envelope fs-5" })
								),
								h.div(
									{},
									h.div({ class: "text-muted small text-uppercase fw-bold", style: "font-size: 0.7rem; letter-spacing: 0.5px;" }, "Email Address"),
									h.div({ class: "fw-semibold text-dark text-break" }, user?.email)
								)
							),

							// Phone
							h.div(
								{ class: "d-flex align-items-center gap-3 p-2 rounded-3 hover-bg-light transition-all" },
								h.div(
									{ class: "bg-success-subtle text-success rounded-3 p-2.5 d-flex align-items-center justify-content-center", style: "width: 40px; height: 40px;" },
									h.i({ class: "bi bi-telephone fs-5" })
								),
								h.div(
									{},
									h.div({ class: "text-muted small text-uppercase fw-bold", style: "font-size: 0.7rem; letter-spacing: 0.5px;" }, "Phone Number"),
									h.div(
										{ class: "fw-semibold text-dark" },
										user?.phone ? `+254 ${user.phone.substring(user.phone.length - 9)}` : "No phone number"
									)
								)
							)
						)
					)
				),

				// Quick Navigation Actions
				h.div(
					{ class: "d-grid gap-4 mb-4" },
					h.button(
						{
							class: "btn btn-white border shadow-sm rounded-4 p-3 d-flex align-items-center justify-content-between hover-shadow transition-all",
							onclick: "app('router').to('user.edit-profile')"
						},
						h.div(
							{ class: "d-flex align-items-center gap-3 text-start" },
							h.div(
								{ class: "bg-light text-secondary rounded-3 p-2 d-flex align-items-center justify-content-center", style: "width: 38px; height: 38px;" },
								h.i({ class: "bi bi-pencil-square fs-5 text-dark" })
							),
							h.div(
								{},
								h.div({ class: "fw-bold text-dark" }, "Edit Profile Information"),
								h.div({ class: "text-muted small" }, "Update your name, bio, and business info")
							)
						),
						h.i({ class: "bi bi-chevron-right text-secondary" })
					),
					h.button(
						{
							class: "btn btn-white border shadow-sm rounded-4 p-3 d-flex align-items-center justify-content-between hover-shadow transition-all",
							onclick: "app('router').to('user.change-password')"
						},
						h.div(
							{ class: "d-flex align-items-center gap-3 text-start" },
							h.div(
								{ class: "bg-light text-secondary rounded-3 p-2 d-flex align-items-center justify-content-center", style: "width: 38px; height: 38px;" },
								h.i({ class: "bi bi-key fs-5 text-dark" })
							),
							h.div(
								{},
								h.div({ class: "fw-bold text-dark" }, "Change Password"),
								h.div({ class: "text-muted small" }, "Ensure your account's security")
							)
						),
						h.i({ class: "bi bi-chevron-right text-secondary" })
					)
				),

				// Hidden image upload input
				h.input({
					type: "file",
					id: "profile-image-upload",
					class: "d-none",
					accept: "image/*",
					listeners: {
						change: (e) => this.handleImageUpload(e)
					}
				})
			)
		);
	}

	changeAvatar() {
		document.getElementById("profile-image-upload").click();
	}

	handleImageUpload(e) {
		const files = e.target.files;
		if (!files.length) return;

		const file = files[0];
		const fileReader = new FileReader();
		fileReader.readAsDataURL(file);

		fileReader.addEventListener("load", () => {
			const src = fileReader.result;
			const options = new tool.ModalOptions();
			options.buttons.right.text = "Crop & Confirm";
			options.buttons.left.text = "Cancel";
			options.classes.buttons.right = "btn btn-primary rounded-pill px-4";
			options.classes.dialog = "modal-lg modal-fullscreen-md-down";
			options.staticBackdrop();

			const { buttons, modal } = tool.modal(
				"Crop Profile Image",
				h.EditProductImageForm(src),
				options,
			);

			modal.element.addEventListener("shown.bs.modal", () => {
				const preview = dom.id("epif-image-view");
				preview.classList.remove("d-none");

				this.cropper.obj = new Cropper(preview, {
					aspectRatio: 1 / 1,
					viewMode: 2,
					minContainerHeight: 350,
				});
			});

			buttons.left.button.addEventListener("click", () => modal.close());

			buttons.right.button.addEventListener("click", async () => {
				if (!this.cropper.obj) return;
				const cropData = this.cropper.obj.getData();
				modal.close();
				await this.uploadProfilePic(file, cropData);
			});
		});
	}

	async uploadProfilePic(file, cropBox) {
		try {
			broker.broadcast($e.app.indicator.process.start);

			const arrayBuffer = await file.arrayBuffer();
			const robustBlob = new Blob([arrayBuffer], { type: file.type });

			const formData = new FormData();
			formData.append("image", robustBlob);
			formData.append("crop_using", JSON.stringify(cropBox));

			const res = await api.post(
				"users/profile-picture",
				formData,
				{
					fetch_using: "browser",
					"remove-content-type": true,
				}
			);
			if (res) {
				inform(res.message || "Profile picture updated successfully", STRINGS.SUCCESS);
				gc.user.value = res.data.user;
			}
		} catch (error) {
			inform(
				error.response?.data?.message || "Failed to upload image",
				STRINGS.ERROR
			);
		} finally {
			broker.broadcast($e.app.indicator.process.end);
		}
	}
}
